<template>
  <nd-dialog
    v-model="visible"
    close-btn
    :footer="false"
    class="privilege-dialog"
  >
    <div class="dialog-box">
      <div class="box-header">{{title}}</div>
      <div class="box-content">
        <template v-for="(item, index) in content">
          <p :key="`title-${index}`" class="content-title">{{item.title}}</p>
          <p :key="`info-${index}`" class="content-info">{{item.info}}</p>
        </template>
      </div>
      <div class="box-button" @click="$emit('click')">立即领取</div>
      <div class="box-tips">领取即同意<span @click="routerToVipProtocol">《VIP会员协议》</span></div>
    </div>
  </nd-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    routerToVipProtocol () {
      this.visible = false
      this.$router.push('/protocol/vip')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.privilege-dialog{
  /deep/.default-content{
    padding-top: 0;
  }
  .dialog-box {
    display: flex;
    flex-direction: column;
    align-items: start;
    padding-bottom: 50px;
    .box-header{
      height: 120px;
      line-height: 120px;
      width: 100%;
      color: #fff;
      font-weight: bold;
      font-size: 42px;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      text-align: center;
    }
    .box-content{
      overflow: hidden;
      padding: 0 50px;
      .content-title{
        font-size: 32px;
        color: #333333;
        font-weight: bold;
        line-height: 45px;
        margin-top: 55px;
      }
      .content-info{
        font-size: 28px;
        color: #666666;
        margin-top: 10px;
        line-height: 40px;
      }
    }
    .box-button{
      width: 380px;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border-radius: 47px;
      font-size: 32px;
      color: #fff;
      margin: 55px auto 0;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
    }
    .box-tips{
      width: 100%;
      font-size: 24px;
      color: #999999;
      margin-top: 20px;
      line-height: 33px;
      text-align: center;
      span{
        color: #8EB2D8;
      }
    }
  }
}
</style>